import styled from 'styled-components';

export const Logo = styled.div`
  display: flex;
  align-items: center;
  img {
    width: 100px;
    padding: 0;
    margin-right: 7px;
  }
`;

export const Profile = styled.div`
  display: flex;
  > div {
    text-align: right;
    margin-right: 10px;
    > div > a {
      padding: 0;
      color: rgba(255, 255, 255, 1) !important;
      svg {
        margin-right: 4px;
      }
    }
    > div > div {
      padding: 6px;
    }
  }
  img {
    height: 40px;
    width: 40px;
    border-radius: 50%;
    overflow: hidden;
  }
`;

export const Icones = styled.div`
  display: flex;
  justify-content: space-between;
  width: 65px;
  svg {
    :hover {
      cursor: pointer;
    }
  }
  span {
    height: 20px;
    width: 20px;
    border-radius: 50%;
    background-color: #cd1205;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    margin-top: -6px;
    margin-right: -2px;
  }
`;

export const DivFormBusca = styled.div`
  display: flex;

  & > div {
    flex: 1;
  }

  button {
    align-self: end;
    margin-left: 2px;
    padding-top: 0.4rem;
  }
`;
